import { MessageId as MessageIdSchema } from "@redotech/effect-api-shared/ids/definitions";
import type { SaveDraftInput } from "@redotech/effect-api-shared/models/shopper-ai/conversation/draft";
import type { SupportTicketDraftResponse } from "@redotech/effect-api-shared/rpc/support-ticket";

export type DraftCollectionItem = Omit<
  SupportTicketDraftResponse,
  "inReplyToMessageId"
> & { inReplyToMessageId: string | undefined };

export function buildSaveDraftPayload(
  item: DraftCollectionItem,
): SaveDraftInput {
  const inReplyToMessageId = item.inReplyToMessageId
    ? MessageIdSchema.make(item.inReplyToMessageId)
    : undefined;
  const plainContent = item.plainContent ?? undefined;

  if (item.channel === "gmail" || item.channel === "outlook") {
    return {
      threadId: item.threadId,
      inReplyToMessageId,
      content: item.content,
      plainContent,
      attachments: item.attachments,
      channel: item.channel,
      channelData: item.channelData ?? {},
    };
  }
  return {
    threadId: item.threadId,
    inReplyToMessageId,
    content: item.content,
    plainContent,
    attachments: item.attachments,
    channel: item.channel,
    channelData: null,
  };
}
